// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__I6BNT","resendInfoText":"OnGoingPaymentBox_resendInfoText__2oDNR"};